module.exports = __webpack_public_path__ + "img/eclient@2x.c66e738b.png";